import React, { FC } from "react";
import CountdownTimer from "../../Unknown/CountdownTimer";
import Box from "../../Unknown/Box";
import Paper from "../../Unknown/Paper";
import Typography from "../../Unknown/Typography";
import useCountdownTimer from "../../../hooks/useCountdownTimer";
import getCountdownTimerProps from "./getCountdownTimerProps";
import useTranslations from "./useTranslations";
import useStyles from "./useStyles";

type AppointmentUpsellTimerProps = {
  expiresAt: number;
  durationInSeconds: number;
};

const AppointmentUpsellTimer: FC<AppointmentUpsellTimerProps> = ({
  expiresAt,
  durationInSeconds,
}) => {
  const { timerPaperRoot } = useStyles();

  const {
    translations: { timerTitle },
  } = useTranslations();

  const { time } = useCountdownTimer({ expiresAt });

  const { text, countdownValue } = getCountdownTimerProps({
    timeToEnd: time,
    checkoutDurationSeconds: durationInSeconds,
  });

  return (
    <Box>
      <Paper classes={{ root: timerPaperRoot }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexGrow={1}
          gap={4}
        >
          <Typography>{timerTitle}</Typography>
          <CountdownTimer
            color="error"
            text={text}
            textVariant="body2"
            textColor="text.primary"
            thickness={4}
            value={countdownValue}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default AppointmentUpsellTimer;
